module.exports = __webpack_public_path__ + "img/guess-number-details1.1eec6de8.png";